module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "album-card"
  }, [(_vm.isShowPromoteModal) ? _c('promote-modal', {
    attrs: {
      "item": _vm.album,
      "dismiss": _vm.dismissPromoteDialog,
      "success": _vm.saveAndFinish
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "album-info",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('v-flex', {
    staticClass: "album-cover",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "album-image",
    style: ({
      'background-image': 'url(' + _vm.album.cover.url + ')'
    })
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "album-actions",
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + (_vm.album.album_type) + "/" + (_vm.album.slug))
    }
  }, [_c('v-flex', {
    staticClass: "touch-flex",
    attrs: {
      "xs12": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "full-height",
    attrs: {
      "xs12": "",
      "pt-2": ""
    }
  }, [(_vm.acceptButtonFunc) ? [_c('div', {
    staticClass: "label-user-avatar",
    style: (("background-image: url(" + (_vm.user.avatar.url) + ")"))
  }), _vm._v(" "), _c('div', {
    staticClass: "label-username"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('div', {
    staticClass: "label-description"
  }, [_vm._v("\n              wants to add this album to their catalog\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "label-actions-section"
  }, [_c('v-btn', {
    staticClass: "action-btn accept",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.acceptButtonFunc(_vm.album, _vm.user)
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('v-btn', {
    staticClass: "action-btn deny",
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.denyButtonFunc(_vm.album, _vm.user)
      }
    }
  }, [_vm._v("Deny")])], 1)] : [(_vm.status && _vm.status != '') ? _c('v-btn', {
    staticClass: "action-btn",
    attrs: {
      "dark": ""
    }
  }, [_vm._v(_vm._s(_vm.status))]) : _vm._e(), _vm._v(" "), (_vm.deleteButtonFunc) ? _c('v-btn', {
    staticClass: "action-btn",
    class: _vm.deleteButtonClass,
    attrs: {
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.deleteButtonFunc(_vm.album, _vm.user)
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.deleteButtonText)
    }
  })]) : _vm._e()]], 2), _vm._v(" "), (!_vm.acceptButtonFunc && _vm.album.tracks) ? _c('p', {
    staticClass: "album-count"
  }, [_vm._v("\n          " + _vm._s(_vm.album.tracks) + " tracks\n        ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "album-detail",
    attrs: {
      "xs12": "",
      "pa-0": ""
    }
  }, [_c('p', {
    staticClass: "album-name"
  }, [_vm._v(_vm._s(_vm.album.name))]), _vm._v(" "), _c('p', {
    staticClass: "album-posted-date"
  }, [_vm._v("2 months")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f4b2b48","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/label/components/album.vue
// module id = 1691
// module chunks = 180